import React from 'react';

const CommonCompatibilityUpdateWarning = (props) => {
  const {featureGroup, featureGroupName, } = props;
  void featureGroup;

  return (
    <div className="compatibility-warning">
      <p>
        <strong>The {featureGroupName} previously selected is not supported by the material. </strong>
        Please choose a new compatible {featureGroupName} from the panel below.
      </p>
      <p>
        We've opened the {featureGroupName} Options Panel for you to make a quick update.
      </p>
    </div>
  );
};

export default CommonCompatibilityUpdateWarning;
